// dayjs
import dayjs from "dayjs";
import isBetween from 'dayjs/plugin/isBetween';
import isSameOrAfter from 'dayjs/plugin/isSameOrAfter';
import isSameOrBefore from 'dayjs/plugin/isSameOrBefore';
import { Schedule } from "../types/schedule";
// プラグインが必要
import ja from 'dayjs/locale/ja';
import { User } from "../types/user";
dayjs.locale(ja);
dayjs.extend(isSameOrAfter);
dayjs.extend(isSameOrBefore);
dayjs.extend(isBetween);

export default class Utils {

    /**
     * 時間外
     * @param target 
     * @param start 
     * @param end 
     * @returns 
     */
    static outsideBusinessHours = (target: string, start: string, end: string): boolean => {
        
        const today = dayjs();
        const targetTime = dayjs(target);
        const targetDate = targetTime.format('YYYY-MM-DD');
        const startTime = dayjs(`${targetDate} ${start}`);
        const endTime = dayjs(`${targetDate} ${end}`);

        if (!today.isBefore(targetTime)) {
            return false;
        }

        if (!startTime.isAfter(targetTime) && !endTime.isBefore(targetTime)) {
            return true;
        }
        return false;
    }

    /**
     * ios → yyyy年mm月dd日 hh:mm
     * @param isoString 
     * @returns 
     */
    static iosToDateString = (isoString: string): string => {
        return dayjs(isoString).format('YYYY年MM月DD日 HH:mm');
    };

    /**
     * ios → yyyy-mm-dd
     * @param isoString 
     * @returns 
     */
    static iosToYYYYMM = (isoString: string): string => {
        return dayjs(isoString).format('YYYY-MM');
    };

    /**
     * ios → yyyy-mm-dd
     * @param isoString 
     * @returns 
     */
    static iosToYYYYMMDDhhmm = (isoString: string): string => {
        return dayjs(isoString).format('YYYY-MM-DD hh:mm');
    };

    static dateStringToIos = (dateString: string): string => {
        return dayjs(dateString).toISOString();;
    };

        /**
     * ローカルストレージのuser配列と色見本の一覧作成
     * @returns 
     */
    static getUserColorMap = (): Record<string, string> => {
        const authRaw = localStorage.getItem("auth");
        if (!authRaw) return {};
        try {
            const auth = JSON.parse(authRaw);
            const users = Array.isArray(auth.users) ? auth.users : [];
            const colors = ['#F1A983', '#8ED973', '#61CBF3', '#D86DCD' ];

            return users.reduce((map: Record<string, string>, user: User, index: number) => {
                map[user.userId] = colors[index % colors.length];
                return map;
            }, {});
        } catch {
            return {};
        }
    };

    /**
     * スケジュールに色見本を適合
     * @param schedules 
     * @returns 
     */
    static applyColorsToSchedules = (schedules: Schedule[]): Schedule[] => {
        const userColorMap = this.getUserColorMap();
        return schedules.map(schedule => ({
            ...schedule,
            backgroundColor: userColorMap[schedule.userId] ?? '#4D93D9', // デフォルト色
        }));
    };

    /**
     * 月が一致するか判定
     * @param start 
     * @param end 
     * @returns 
     */
    static isMatchMonth = (start: string, end: string): boolean => {
        const dayjsStart = dayjs(start).format('YYYY-MM');
        const dayjsEnd = dayjs(end).format('YYYY-MM');
        return dayjsStart !== dayjsEnd;
    }


    /**
     * 月からカレンダーに表示された時の日付を返す
     * @param currentDateStr 
     * @param firstDay 
     * @returns 
     */
    static getMonthViewGridRange = (currentDateStr: string, firstDay: number = 0) => {
        const center = dayjs(currentDateStr);
        const startOfMonth = center.startOf("month");
        const endOfMonth = center.endOf("month");

        // 月ビューで表示されるグリッドは firstDay（例：日曜 or 月曜）を基準に週開始〜週終了になる
        const start = startOfMonth.subtract((startOfMonth.day() - firstDay + 7) % 7, "day");
        const end = endOfMonth.add((6 - endOfMonth.day() + firstDay) % 7, "day");

        const startDate = start.startOf("day");
        const endDate = end.endOf("day"); 

        return {
            start: startDate.toISOString(),
            end: endDate.toISOString(),
        };
    }

}